import { UserStatusEnum } from "./type";

export const getUserStatus = (status: UserStatusEnum) => {
  switch (status) {
    case UserStatusEnum.CONFIRMED:
      return {
        color: "rgba(41, 217, 133, 1)",
        background: "rgba(41, 217, 133, .15)",
        title: "Confirmed",
      };

    case UserStatusEnum.UNCONFIRMED:
      return {
        color: "rgba(246, 81, 100, 1)",
        background: "rgba(246, 81, 100, .15",
        title: "Unconfirmed",
      };
    case UserStatusEnum.EXTERNAL_PROVIDER:
      return {
        color: "rgba(29, 139, 247, 1)",
        background: "rgba(29, 139, 247, .15)",
        title: "External Provider",
      };
    case UserStatusEnum.FORCE_CHANGE_PASSWORD:
      return {
        color: "rgba(246, 81, 100, 1)",
        background: "rgba(246, 81, 100, .15)",
        title: "Force Change Password",
      };
    case UserStatusEnum.RESET_REQUIRED:
      return {
        color: "#1D8BF7",
        background: "#bddcfb",
        title: "Reset Required",
      };
    default: {
      return {
        color: "transparent",
        backgroundColor: "transparet",
        title: "",
      };
    }
  }
};
